import { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

import { Navigate, useLocation } from 'react-router-dom';

import { connect, useDispatch } from 'react-redux';

import { productsCategories, productsSlugs } from 'constants/products';

import LoadingScene from 'Scenes/LoadingScene';

import * as featureFlagsSelectors from 'dux/featureFlags/selectors';
import * as userSelectors from 'dux/user/selectors';
import { getUserIsLoadingOrEmpty } from 'dux/user/selectors';
import { fetchHairProfileProductVariantBySlug } from 'dux/consultation/thunks';
import { useKustomerLivechat } from 'dux/user/hooks';

import { useCheckoutCategory } from '../hooks/useCheckoutCategory';
import CartContainerLoader from './CartContainerLoader';

const CartContainer = ({
  isFlagsDoneFetching,
  userIsLoadingOrEmpty,
  isFragranceSoldout,
  showLivechat,
}) => {
  const dispatch = useDispatch();
  const checkoutCategory = useCheckoutCategory();
  const { search } = useLocation();
  const params = useMemo(() => new URLSearchParams(search), [search]);

  useEffect(() => {
    if (checkoutCategory === productsCategories.HAIRCARE) {
      dispatch(fetchHairProfileProductVariantBySlug(productsSlugs.LEAVEIN_CONDITIONER));
    }
  }, [checkoutCategory]);

  useKustomerLivechat({
    origin: 'Cart',
    showLivechat,
  });

  /**
   * Temporary thing to remove by the end of 2019
   * this avoids a backend error if we arrive with an old checkout URL
   * like /checkout?pubkey=__something__
   * the current cart expects a pubkey only if gift origin
   */
  const invalidParams = params.has('pubkey') && params.get('origin') !== 'gift';

  if (invalidParams) {
    return <Navigate replace to="/checkout/haircare" />;
  }

  if (checkoutCategory === productsCategories.HAIRCARE && isFragranceSoldout) {
    return <Navigate replace to="/consultation/haircare/my-preferences/fragrance?standalone" />;
  }

  if (!isFlagsDoneFetching || userIsLoadingOrEmpty) {
    return <LoadingScene />;
  }

  return <CartContainerLoader params={params} />;
};

CartContainer.propTypes = {
  isFlagsDoneFetching: PropTypes.bool.isRequired,
  userIsLoadingOrEmpty: PropTypes.bool.isRequired,
  isFragranceSoldout: PropTypes.bool.isRequired,
  showLivechat: PropTypes.bool,
};

CartContainer.defaultProps = {
  showLivechat: false,
};

export default connect(state => ({
  isFlagsDoneFetching: featureFlagsSelectors.isFlagsDoneFetching(state),
  userIsLoadingOrEmpty: getUserIsLoadingOrEmpty(state),
  isFragranceSoldout: userSelectors.getUserFragranceIsSoldOut(state),
  showLivechat: featureFlagsSelectors.shouldShowKustomerLivechatAtCart(state),
}))(CartContainer);
